document.addEventListener('alpine:init', () => {
    function faqAccordion(serverFaqs = []) {
        return {
            openItem: null,
            showAll: false,
            items: serverFaqs,
            get visibleItems() {
                return this.showAll ? this.items : this.items.slice(0, 3);
            }
        };
    }

    Alpine.data('faqAccordion', faqAccordion);

    /* we are not using these but one has to be used for hero slider because it stopped working */

    /* Alpine.data('accordion', () => {
        const jsonScript = document.getElementById('accordion-data');
        let items = [];

        if (jsonScript) {
            try {
                items = JSON.parse(jsonScript.textContent);
            } catch (e) {
                console.error("Fehler beim Parsen der Accordion-Items:", e);
            }
        }

        return {
            openItem: 0,
            items
        };
    });


    Alpine.data('heroSlider', () => ({
        slides: window.heroSlides || [],
        current: 0,
        next() {
            this.current = (this.current + 1) % this.slides.length;
        },
        prev() {
            this.current = (this.current - 1 + this.slides.length) % this.slides.length;
        }
    }));

    Alpine.data('imageSlider', (initialImages) => ({
        images: initialImages,
        current: 0,
        timer: null,
        init() {
            this.timer = setInterval(() => this.next(), 10000);
        },
        next() {
            this.current = (this.current + 1) % this.images.length;
        },
        prev() {
            this.current = (this.current - 1 + this.images.length) % this.images.length;
        }
    }));

    Alpine.data('sliderImages', () => ({
        images: [
            '/images/full-screen-slider-1.png',
            '/images/full-screen-slider-2.jpg',
            '/images/full-screen-slider-3.png'
        ],
        current: 0,
        next() {
            this.current = (this.current + 1) % this.images.length;
        },
        prev() {
            this.current = (this.current - 1 + this.images.length) % this.images.length;
        }
    }));

    Alpine.data('sliderSlides', () => ({
        current: 0,
        slides: [
            {
                label: 'Aktion',
                title: 'Holen Sie sich Ihre maßgeschneiderten Traumvorhänge noch heute nach Hause',
                button_text: 'Aktionsangebot ansehen',
                button_link: '#contact',
                image: '/images/full-screen-slider-1.png'
            },
            {
                label: 'Neuheit',
                title: 'Vorhänge, die Ihr Zuhause verändern',
                button_text: 'Angebot ansehen',
                button_link: '#ponuka',
                image: '/images/full-screen-slider-2.jpg'
            },
            {
                label: 'Inspiration',
                title: 'Qualität, die Sie verdienen',
                button_text: 'Mehr erfahren',
                button_link: '#viac',
                image: '/images/full-screen-slider-3.png'
            }
        ],
        next() {
            this.current = (this.current + 1) % this.slides.length;
        },
        prev() {
            this.current = (this.current - 1 + this.slides.length) % this.slides.length;
        }
    })); */

});

// Swiper initialization - separate from Alpine to ensure DOM is ready
document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.mySwiper', {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000, // Changed from 500000 to 5000 (5 seconds)
            disableOnInteraction: false
        },
        speed: 1000,
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });
});
